import { render, staticRenderFns } from "./barrageList.vue?vue&type=template&id=7db50410&scoped=true"
import script from "./barrageList.vue?vue&type=script&lang=js"
export * from "./barrageList.vue?vue&type=script&lang=js"
import style0 from "./barrageList.vue?vue&type=style&index=0&id=7db50410&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db50410",
  null
  
)

export default component.exports